import { useEffect, useState } from 'react';

import { Modal } from '@cfa/react-core';

import { cn } from '@/utils/tailwind';

import { ScrollModalProps } from './ScrollModalFooter';
export interface ScrollModalHeaderProps extends ScrollModalProps {
  className?: string;
  headerTitle?: string;
}

const ScrollModalHeader: React.FC<ScrollModalHeaderProps> = ({
  scrollRef,
  children,
  className,
  headerTitle,
  ...props
}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const updateScrollStatus = () => {
      setIsScrolled(el.scrollTop !== 0);
    };

    el.addEventListener('scroll', updateScrollStatus);

    return () => el.removeEventListener('scroll', updateScrollStatus);
  }, [scrollRef]);

  return (
    <div
      className={cn(
        'z-5!',
        {
          'dark:border-outline-2! shadow-[0_8px_16px_-8px_rgba(0,0,0,0.16)]! dark:border-b dark:shadow-none!':
            isScrolled,
        },
        className,
      )}
      {...props}
    >
      {headerTitle && (
        <Modal.Title className="text-variant-h3! text-center">
          {headerTitle}
        </Modal.Title>
      )}
      {children}
    </div>
  );
};

export default ScrollModalHeader;
